module.exports = __webpack_public_path__ + "static/media/icon.d48a9e38.png";